import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=086ab628&scoped=true"
import script from "./ProductPage.vue?vue&type=script&lang=ts"
export * from "./ProductPage.vue?vue&type=script&lang=ts"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=086ab628&prod&lang=scss&scoped=true"
import style1 from "./ProductPage.vue?vue&type=style&index=1&id=086ab628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086ab628",
  null
  
)

export default component.exports